
export type ISubProjectState = {
    id: number;
    name: string;
}

export enum ISubProjectActionTypes {
    FETCH_SUB_PROJECT_LIST_REQUEST = 'FETCH_SUB_PROJECT_LIST_REQUEST',
    FETCH_SUB_PROJECT_LIST_SUCCESS = 'FETCH_SUB_PROJECT_LIST_SUCCESS',
    FETCH_SUB_PROJECT_LIST_FAILURE = 'FETCH_SUB_PROJECT_LIST_FAILURE',

}

export type ISubProjectActionCreator = {
    type: string;
    payload: ISubProjectState;
  };
